import React from "react";
//@ts-ignore
import tripode from "src/assets/images/tripode1.jpg";
import { Minus, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
interface Props {
    item: {
        title: string;
        id: number;
        quantity: number;
        price: number;
    };

    updateQuantity: (id: number, args2: number) => void;
}
const TripodsStepCard = ({ item, updateQuantity }: Props) => {
    const { t } = useTranslation();
    return (
        <div
            key={item.id}
            className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200"
        >
            {/* Image */}
            <div className="relative h-72 overflow-hidden">
                <img
                    src={tripode}
                    alt={item.title}
                    className="w-full h-full object-contain transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                    <div className="bg-white/90 backdrop-blur-sm rounded-full px-3 py-1">
                        <span className="text-sm font-semibold text-gray-800">
                            €{item.price}
                        </span>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="p-6">
                <div className="mb-4">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {item.title}
                    </h3>
                </div>

                {/* Quantity Controls */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <span className="text-sm font-medium text-gray-700">
                            {t("tripodsStep.quantity")}:
                        </span>
                        <div className="flex items-center gap-3 bg-gray-100 rounded-full p-1">
                            <button
                                onClick={() => updateQuantity(item.id, -1)}
                                disabled={item.quantity === 0}
                                className="w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center text-gray-600 hover:text-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <Minus size={16} />
                            </button>
                            <span className="w-8 text-center font-semibold text-gray-900">
                                {item.quantity}
                            </span>
                            <button
                                onClick={() => updateQuantity(item.id, 1)}
                                className="w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center text-gray-600 hover:text-blue-600 transition-colors"
                            >
                                <Plus size={16} />
                            </button>
                        </div>
                    </div>

                    {/* Price Display */}
                    {item.quantity > 0 && (
                        <div className="text-right">
                            <div className="text-lg font-bold text-blue-600">
                                €{(item.price * item.quantity)?.toFixed(2)}
                            </div>
                            <div className="text-sm text-gray-500">
                                €{item.price} × {item.quantity}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TripodsStepCard;
